import { BillingCycles } from '../entities';

export default class BillingCycleStore {
  get billingCycles() {
    return BillingCycles.defaultValues();
  }
}
